var map = {
	"./NIM_Web_SDK_v5.8.0": "YQnT",
	"./NIM_Web_SDK_v5.8.0.js": "YQnT",
	"./NIM_Web_SDK_v6.1.0": "EMu8",
	"./NIM_Web_SDK_v6.1.0.js": "EMu8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Sfw4";


//////////////////
// WEBPACK FOOTER
// ./src/im/sdk ^\.\/.*$
// module id = Sfw4
// module chunks = 130